export default __webpack_public_path__ + "static/media/code.36387663.svg";